import * as React from 'react';
import classNames from 'classnames';
import {Filter} from 'interfaces';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';
import * as locales from '../../locales';
import {FilterSectionOption} from '../FilterSectionOption';
import {FilterUpdateFunction, FilterResetFunction} from '../../ShopFilters';

function NOOP() {}

export interface FilterSectionProps {
  bordered: boolean;
  filter: Filter;
  onInputChange?: FilterUpdateFunction;
  onReset?: FilterResetFunction;
  namespace?: string;
}

type ComposedProps = WithI18nProps & FilterSectionProps;

const style = {
  label: 'shop-filters__name heading--4',
  labelGutterBottom: 'gutter-bottom--reset',

  filterList: 'shop-filters__list gutter-bottom--reset',
  borderedFilterList: 'shop-filters__list--bordered',

  filterNote: 'text-muted gutter-bottom--half',
  filterReset: 'body-link',
};

function filterHasValue(filter) {
  return Boolean(filter.options.find((option) => option.checked));
}

class FilterSectionComponent extends React.Component<ComposedProps> {
  handleResetClick = () => {
    const {filter, onReset = NOOP} = this.props;
    onReset(filter.type);
  };

  render() {
    const {
      i18n,
      filter,
      bordered,
      namespace,
      onInputChange = NOOP,
    } = this.props;

    const labelClass = classNames(
      style.label,
      {[style.labelGutterBottom]: Boolean(filter.note)},
    );

    return (
      <React.Fragment>
        <span className={labelClass}>{filter.label}</span>
        { filter.note ? <p className={style.filterNote}>{filter.note}</p> : null }
        <ul className={classNames(style.filterList, {[style.borderedFilterList]: bordered})}>
          {filter.options.map((option) => (
            <FilterSectionOption
              key={option.optionId}
              option={option}
              namespace={namespace}
              filterType={filter.type}
              onInputChange={onInputChange}
              filterOptionState={option.checked}
            />
          ))}
        </ul>
        {filterHasValue(filter) && (
          <button
            type="button"
            onClick={this.handleResetClick}
            className={style.filterReset}
          >{i18n.translate('resetFilterCTA')}</button>
        )}
      </React.Fragment>
    );
  }
}

export const FilterSection = withI18n({
  id: 'ShopFilters',
  fallback: locales.en,
})(FilterSectionComponent);

export default FilterSection;
